import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { GroupsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-groups.sass');

export class GroupsWidget extends WidgetBase {
    public static _name: string = 'User Groups';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-groups';
    public static icon: string = 'tags';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-groups'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(GroupsWidget);
